import i18n from 'atpjs/helpers/i18n'
import { getTopics } from 'tve/api/atp'
import { dayWithDateTime, formatTime } from 'tve/helpers/date'
import { parseISO } from 'date-fns'

const t = i18n.prefix(['components', 'navigation'], 'deep')

export const formatAppointment = (event) => {
  const start = parseISO(event.get('start'))
  const end = parseISO(event.get('end'))
  return dayWithDateTime(start) + ' - ' + formatTime(end)
}

export const namesToString = (subjectNames) => {
  const last = subjectNames.last()
  if (subjectNames.size == 1) return last
  const newSubjects = subjectNames.slice(0, -1)
  return `${newSubjects.join(', ')} ${t(['and'])} ${last}`
}

export const generateSubjects = (subjects) => {
  const topics = getTopics()
  const subjectNames = subjects.map((subject) => {
    const topic = topics.find((topic) => topic.get('code') == subject)
    if (topic) return topic.get('name')
    return subject
  })
  return namesToString(subjectNames)
}

export const generatePhrase = (data, step) => {
  const fn = {
    login: () => t(['steps', 'login', data.get('login') ? 'existing' : 'new']),
    customerType: () => t(['steps', 'customerType', data.get('customerType')]),
    subject: () => t(['steps', 'subject'], { subject: generateSubjects(data.get('subject')) }),
    branch: () => {
      const advisor = data.get('advisor')
      const branch = data.get('branch')

      if (!branch && !!advisor) {
        return t(['steps', 'branch', 'advisor', data.get('medium')], {
          name: `${advisor.get('firstName')} ${advisor.get('lastName')}`
        })
      }

      const city = advisor
        ? advisor
            .get('branches')
            .find((branch) => branch?.get('id') === data.getIn(['branch', 'id']))
            ?.get('city')
        : data.getIn(['branch', 'city'])

      return t(['steps', 'branch', data.get('customerType'), data.get('medium')], { city })
    },
    appointment: () => t(['steps', 'appointment'], { appointment: formatAppointment(data.get('event')) })
  }[step]
  if (fn) return fn()
  return null
}
